<template>
  <div class="test-quality">
    <HeadedContainer color="#E8282F">
      <template v-slot:header>
        {{$ml.get(`WATER QUALITY`)}}
      </template>
      <!-- <div class="form">
        <div class="item" v-for="item in warnings">
          <div class="icon-container">
            <WarningIcon/>
          </div>
          <div class="text">
            {{$ml.get("There is potential for emitter clogging due to high pH.")}} ({{ item.key }})
          </div>
        </div>
      </div> -->
    </HeadedContainer>
  </div>
</template>

<script>
import HeadedContainer from '@/components/common/HeadedContainer'
import WarningIcon from './WarningIcon'
import { mapGetters } from 'vuex';

export default {
  components: {
    HeadedContainer,
    WarningIcon,
  },
  computed: {
    ...mapGetters({
      warnings: 'tests/water/warnings',
    }),
  }
}
</script>

<style lang="scss" scoped>

.form {
  display: flex;
  flex-direction: column;
  padding: 30px;
  width: 100%;

  .item {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;

    .icon-container {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;

      width: 40px;
      height: 30px;
    }

    .text {
      color: #E8282F;
      font-weight: bold;
      font-size: 16px;
      line-height: 30px;
    }
  }
}

</style>
